import { DeviceAuthenticatorModule } from './DeviceAuthenticatorModule';
import { BroadcastMessage } from '@map/core';

/**
 * Device authentication message
 */
export class DeleteBindingsMessage extends BroadcastMessage {
  readonly tag: string = DeviceAuthenticatorModule.deleteBindingsMessageTag;
}
